import React from 'react';
import './Checkbox.scss';

function Checkbox({type, id, name, validateScroll, dataTestId, checked, onChange}) {
  return (
    <div>
      <input
        type={type}
        id={id}
        name={name}
        className='prequal--wc-checkbox-terms-consent-fomo'
        disabled={validateScroll}
        data-testid={dataTestId}
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
}

export default Checkbox;
